<template>
  <b-modal v-model="show" centered title="Neues Konto"
  >
      <b-row class="justify-content-md-center">
        <b-col>
          <label for="name">Bezeichnung</label>
          <b-form-input id="name" type="text"
                        v-model="hh.name"
                        class="mb-2 text-black"
                        maxlength="50"
                        :state="nameError ? false : null"
                        @focusin="nameError = false"
          ></b-form-input>
          <b-form-text style="text-align: right" v-if="!nameError">{{hh.name.length}}/50</b-form-text>
          <b-form-text style="text-align: right; color: red !important;" v-if="nameError">Der Name darf nicht leer sein.</b-form-text>
          <b-row>
            <b-col><label for="name">Konto</label></b-col>
            <b-col><b-form-checkbox
                v-model="ignoreRegex"
                :value="true"
                :unchecked-value="false"
                style="float: right"
            >
              Format ignorieren
            </b-form-checkbox></b-col>
          </b-row>
          <b-form-input id="name" type="text"
                        v-model="hh.account"
                        class="mb-2 text-black"
                        maxlength="50"
                        :placeholder="ignoreRegex ? '' : hhMask"
                        @focusin="hhError = false"
                        :state="hhError && !ignoreRegex ? false : null"
          ></b-form-input>
          <b-form-text style="text-align: right" v-if="ignoreRegex || (hhMask === '' && !hhError)">{{hh.account.length}}/50</b-form-text>
          <b-form-text style="text-align: right" v-if="!ignoreRegex && hhMask !== '' && !hhError">{{hhMask}}<br>{{hhDesc}}<br>9: Zahl; X: Buchstabe; Sonderzeichen direkt eingeben</b-form-text>
          <b-form-text style="text-align: right; color: red !important;" v-if="!ignoreRegex && hhError">Das eingegebene Konto entspricht nicht dem vorgegebenem Format.</b-form-text>
          <label for="anrede">Kontoart</label>
          <b-form-select :options="inOutSelects" id="anrede" :plain="true"
                         v-model="hh.in_out"
                         class="text-black mb-3"
          ></b-form-select>
        </b-col>
      </b-row>
    <template #modal-footer="{ok, cancel}">
      <!-- Emulate built in modal footer ok and cancel button actions -->
      <b-button size="md" variant="primary" @click="onCancel">
        Abbrechen
      </b-button>
      <b-button size="md" variant="success" @click="onSave">
        Speichern
      </b-button>
    </template>
  </b-modal>
</template>

<script>

export default {
  name: "CreateAddressDialog",
  props:{
    hhMask: {
      type: String,
      default: () => ''
    },
    hhDesc: {
      type: String,
      default: () => ''
    },
  },
  computed: {
    hhReg() {
      if (!this.hhMask) {
        return null;
      }
      // Initialize an empty string for the regex
      let regex = '';

      // Iterate through each character in the mask
      let i = 0;
      while (i < this.hhMask.length) {
        let char = this.hhMask[i];
        let count = 1;

        // Count consecutive occurrences of the same character
        while (i + 1 < this.hhMask.length && this.hhMask[i + 1] === char) {
          count++;
          i++;
        }

        switch (char) {
          case '9':
            // '9' should be replaced by \d to match any digit
            regex += `\\d{${count}}`;
            break;
          case 'X':
            // 'X' should be replaced by [A-Za-z] to match any letter
            regex += `[A-Za-z]{${count}}`;
            break;
          default:
            // Any other character should be escaped and added as is
            regex += char.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + (count > 1 ? `{${count}}` : '');
        }
        i++;
      }

      return new RegExp(`^${regex}$`);
    },
  },
  data() {
    return {
      show: false,
      inOutSelects: [
        {value: 'E', text: 'Einnahme'},
        {value: 'A', text: 'Ausgabe'},
        {value: 'X', text: 'Einnahme & Ausgabe'},
      ],
      hh: {
        name: '',
        account: '',
        in_out: '',
      },
      hhError: false,
      nameError: false,
      ignoreRegex: false,
    }
  },
  methods: {
    showModal(currentHhType) {
      this.hh = {
        name: '',
        account: '',
        in_out: currentHhType,
      };
      this.hhError = false;
      this.nameError = false;
      this.ignoreRegex = false;
      this.show = true;
    },
    getReturnData() {
      return this.hh;
    },
    async onSave() {
      this.hh.name = this.hh.name.trim();
      if (this.hhReg && !this.hhReg.test(this.hh.account)) {
        this.hhError = true;
      }
      if (this.hh.name === '') {
        this.nameError = true;
      }
      if (this.hhError || this.nameError) {
        return
      }
      let data = this.getReturnData();
      this.$emit('create-hh', data);
      this.show = false;
    },

    onCancel() {
      this.show = false;
    }
  }
}
</script>

<style scoped>
.text-black {
  color: black;
}
.vld-overlay.is-full-page {
  z-index: 1600;
  position: fixed;
}
</style>
